export default {"src":"/_next/static/media/google.94074db3.svg","height":18,"width":18};